import { createContext } from "react";
import { AppUserInfo } from "./AppUserInfo";

export const AppUserInfoContext = createContext(new AppUserInfo(false));
